import angular from 'angular';
import _ from 'lodash';

import { checkDirtyForm, setDirtyForm } from 'app/actions/dirty-forms.actions';
import confirmTemplate from './views/confirm-dialog.html';

class DirtyForm {
  constructor($ngRedux, $rootScope, $state, Notifications) {
    this.$ngRedux = $ngRedux;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.Notifications = Notifications;
    this.restrict = 'A';
  }

  link(scope, element, attr) {
    const elem = element[0];
    const options = scope.$eval(attr.dirtyFormOpts) || {};
    const { name = undefined } = options;

    this.contextClickHandler = (event) => this.browserClickHandler(event, options);
    this.applyHandlers(attr.ngClick, elem, options, this.contextClickHandler);

    scope.$watch(
      () => _.get(options.ctrl, `form.$dirty`),
      (newValue) => {
        if (newValue) this.$ngRedux.dispatch(setDirtyForm(name, !!newValue));
      }
    );

    scope.$on('$destroy', () => this.removeHandlers(!!attr.ngClick, elem, options, this.contextClickHandler));
  }

  applyHandlers(hasNgClick, element, options, browserClickHandler) {
    if (hasNgClick) {
      // options.ctrl.blockButton = true;
      element.addEventListener('click', browserClickHandler);
    } else {
      this.stateOff = this.$rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) =>
        this.stateChangeStartHandler(event, options, toState, toParams, fromState, fromParams)
      );
    }
  }

  removeHandlers(hasNgClick, element, options, browserClickHandler) {
    if (hasNgClick) {
      options.ctrl.blockButton = false;
      element.removeEventListener('click', browserClickHandler);
    } else {
      this.stateOff();
    }
  }

  browserClickHandler(event, options) {
    const dirty = this.$ngRedux.dispatch(checkDirtyForm(options.name || undefined));
    if (dirty) {
      this.Notifications.showSimpleDialog(confirmTemplate).result.then(() => {
        const callbackName = options.callbackName || 'toggleEditMode';
        const callbackFn = _.get(options.ctrl, `api.${callbackName}.run`) || (() => {});
        callbackFn(options.namespace, options.moduleName);
        const form = _.get(options, 'ctrl.form');
        this.$ngRedux.dispatch(setDirtyForm(options.name, false));
        if (form) {
          form.$setPristine();
        }
      });
    }
  }

  stateChangeStartHandler(event, options, toState, toParams, fromState, fromParams) {
    const dirty = this.$ngRedux.dispatch(checkDirtyForm(options.name || undefined));
    if (dirty && !toParams.skipDirtyForms) {
      event.preventDefault();
      this.$state.go(fromState, fromParams);
      this.Notifications.showSimpleDialog(confirmTemplate).result.then(() => {
        const { callbackName } = options;
        const callbackFn = _.get(options.ctrl, `api.${callbackName}.run`) || (() => {});
        callbackFn(options.namespace, options.moduleName);
        const form = _.get(options, 'ctrl.form');
        if (form) {
          form.$setPristine();
        }
        this.removeHandlers();
        this.$ngRedux.dispatch(setDirtyForm(options.name, false));
        this.$state.go(toState, toParams);
      });
    }
  }
}

export default angular
  .module('dirty-form', [])
  .directive('dirtyForm', [
    '$ngRedux',
    '$rootScope',
    '$state',
    'Notifications',
    ($ngRedux, $rootScope, $state, Notifications) => new DirtyForm($ngRedux, $rootScope, $state, Notifications),
  ]);



// WEBPACK FOOTER //
// ./src/modules/utils/dirty-form/dirty-form-directive.js